export default __webpack_public_path__ + "static/media/iconAudifono.da36a662.svg";